// removed by extract-text-webpack-plugin
module.exports = {"spacing-large":"16px","spacing-huge":"32px","thunder":"#6b6e72","wolf":"#dcdee2","this":"EventParticipationForm__this___EIPvY","row":"EventParticipationForm__row___2TfAe","form":"EventParticipationForm__form___2rbrh","textareaInput":"EventParticipationForm__textareaInput___3d4kB","submitButton":"EventParticipationForm__submitButton___DZdGc","divider":"EventParticipationForm__divider___jDB_I","tos":"EventParticipationForm__tos___I9yje","nameInput":"EventParticipationForm__nameInput___3inxH","emailInput":"EventParticipationForm__emailInput___1aIKF"};


//////////////////
// WEBPACK FOOTER
// ./src/payments/components/styles/EventParticipationForm.css
// module id = 1792
// module chunks = 4